import React, { useState, useEffect } from "react";
import "./styles.scss";
import useListQuery from "hooks/useListQuery";
import DataTable from "components/DataTable";
import { getColumns } from "./_components/column";
// import { VectorIcon } from "assets/icons";
import { AnphaIcon } from "assets/icons";
import { Button } from "antd";
import OrderStatsWidgets from "./_components/OrderStatsWidgets";
import OrderService from "services/order";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { ExportFile } from "hooks/FileHandler";
import moment from "moment";
import { useSelector } from "react-redux";
import { useModalDirectLinkContext } from "components/ModalDirectLink";
import ModalProgress from "components/ModalProgress/ModalProgress";
import { ORDER_TYPE } from "constants/order";
import { ORDER_PAYMENT_STATUS } from "constants/order";
import { stations_location } from "constants/order";
import CreateOrder from "./_components/CreateOrder";
import OrderPaymentPage from "./OrderPaymentPage";
import { useLocation } from "react-router-dom";
import { useQueryClient } from "react-query";
import useExportExcel from "hooks/useExportExcel";
import BasicTabs from "components/BasicTabs";
import { ALL_PERMISSION } from "constants/permission";

import HistoryOrder from "./HistoryOrder";
import StatisticsOrder from "./StatisticsOrder";
import ProductSettings from "./ProductSettings";
import CreateOrderPage from "./CreateOrderPage";
import GiftOrder from "./GiftOrder";

const { TabPane } = require("antd").Tabs;

const DefaultFilterExport = {
  limit: 100,
};

const FIELDS_EXPORT_IMPORT = [
  { api: "orderId", content: "order.id" },
  { api: "orderName", content: "order.orderName" },
  { api: "totalAmount", content: "order.totalAmount" },
  { api: "firstName", content: "order.firstName" },
  { api: "email", content: "order.email" },
  { api: "phoneNumber", content: "order.phoneNumber" },
  { api: "orderType", content: "order.orderType" },
  { api: "paymentStatus", content: "order.paymentStatus" },
  { api: "orderStatus", content: "order.orderStatus" },
  { api: "createdAt", content: "order.createdAt" },
];

const ListOrder = () => {
  const { t: translation } = useTranslation();

  const location = useLocation();
  const history = useHistory();
  const params = new URLSearchParams(location.search);
  const paymentMode = params.get("payment") === "true";

  // Clear params when tab changes
  useEffect(() => {
    const currentTab = params.get("tab");
    if (currentTab && currentTab !== "1") {
      // Clear all params except tab when not on tab 1
      const newParams = new URLSearchParams();
      newParams.set("tab", currentTab);
      history.replace(`${location.pathname}?${newParams.toString()}`);
    }
  }, [location.search, history, location.pathname]);

  const listTab = [
    {
      key: "1",
      label: translation("order.createOrder"),
      permission: undefined,
      component: paymentMode ? <OrderPaymentPage /> : <CreateOrderPage />,
    },
    {
      key: "2",
      label: translation("order.historyOrder"),
      permission: undefined,
      component: <HistoryOrder />,
    },
    {
      key: "3",
      label: translation("order.statistics"),
      permission: undefined,
      component: <StatisticsOrder />,
    },
    {
      key: "4",
      label: translation("order.productSettings"),
      permission: undefined,
      component: <ProductSettings />,
    },
    {
      key: "5",
      label: "Quà tặng",
      permission: undefined,
      component: <GiftOrder />,
    },
  ];

  return <BasicTabs tabs={listTab} permissionConstant={ALL_PERMISSION.MANAGE_ORDER.permissionTab} />;
};

export default ListOrder;
